import { useEffect, useRef, useState } from 'react'
import { format, parseISO } from 'date-fns'
import { ru } from 'date-fns/locale'
import Button from '@/components/ui/Button'
import { getMyPairs, PairProposal, respondPair } from '@/services/pairs'

export default function PairActivity({trainerId,onChanged}:{trainerId?:string;onChanged?:()=>void}) {
  const [items,setItems]=useState<PairProposal[]>([])
  const [busy,setBusy]=useState<string|null>(null)
  const [error,setError]=useState('')
  const changed=useRef(onChanged);changed.current=onChanged
  const lastState=useRef<string|null>(null)
  useEffect(()=>{
    let live=true
    const load=()=>getMyPairs().then(data=>{
      if(!live)return
      const signature=data.proposals.map(p=>`${p.id}:${p.status}`).join('|')
      if(lastState.current!==null && lastState.current!==signature)changed.current?.()
      lastState.current=signature
      setItems(data.proposals)
    }).catch(()=>{if(live)setError('Не удалось обновить парные предложения')})
    void load()
    const timer=window.setInterval(load,15000)
    const visible=()=>{if(document.visibilityState==='visible')void load()}
    document.addEventListener('visibilitychange',visible)
    return()=>{live=false;window.clearInterval(timer);document.removeEventListener('visibilitychange',visible)}
  },[trainerId])
  const act=async(p:PairProposal,action:'accept'|'decline'|'cancel')=>{
    if(busy)return
    setBusy(p.id);setError('')
    try{const result=await respondPair(p.id,action);setItems(xs=>xs.map(x=>x.id===p.id?result:x));changed.current?.()}
    catch(e:any){setError(e.response?.data?.detail||'Не удалось обработать предложение')}
    finally{setBusy(null)}
  }
  const labels={accepted:'Парная тренировка подтверждена',declined:'Партнёр отказался от предложенного времени',expired:'Подтверждение не получено в срок',cancelled:'Парная тренировка отменена'}
  const shown=items.filter(p=>p.status!=='accepted'&&(!trainerId||p.trainer_id===trainerId)&&p.date>=format(new Date(),'yyyy-MM-dd')).slice(0,10)
  if(!shown.length&&!error)return null
  return <section className="mb-5 space-y-3" aria-label="Парные предложения">
    {error&&<p role="alert" className="text-sm text-red-600">{error}</p>}
    {shown.map(p=><div key={p.id} className="rounded-xl border border-tg-button/30 bg-tg-secondary p-4">
      <p className="font-semibold">{p.status==='pending'?'Ожидается подтверждение пары':labels[p.status]}</p>
      <p className="mt-1 text-sm">{format(parseISO(p.date),'d MMMM',{locale:ru})}, {p.start_time} – {p.end_time}</p>
      <p className="mt-1 text-sm text-tg-hint">{p.initiator_name} и {p.responder_name}</p>
      {p.status==='pending'&&<>
        <p className="mt-2 text-sm text-tg-hint">Места зарезервированы. Ожидаем подтверждение в течение 2 часов. Запрос также отправлен в бот</p>
        <div className="mt-3 flex flex-wrap gap-2">
          {p.awaiting_my_response&&<><Button disabled={busy!==null} onClick={()=>void act(p,'accept')}>Подтвердить</Button><Button variant="outline" disabled={busy!==null} onClick={()=>void act(p,'decline')}>Отказаться</Button></>}
          {!p.awaiting_my_response&&<Button variant="outline" disabled={busy!==null} onClick={()=>void act(p,'cancel')}>Отменить предложение</Button>}
        </div>
      </>}
    </div>)}
  </section>
}
